import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMember = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.731 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM4 21c0-3.483 3.465-6.3 7.731-6.3.864 0 1.701.117 2.484.333"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M20.731 17.4c0 .288-.036.567-.108.837a3.36 3.36 0 0 1-.414 1.017A3.573 3.573 0 0 1 17.131 21a3.529 3.529 0 0 1-2.394-.927 3.315 3.315 0 0 1-.684-.819 3.529 3.529 0 0 1-.522-1.854 3.595 3.595 0 0 1 3.6-3.6 3.55 3.55 0 0 1 2.673 1.197c.576.639.927 1.485.927 2.403Zm-2.259-.018H15.79m1.341-1.314v2.691"
    />
  </svg>
);
export default SvgMember;
